<template>
  <v-card elevation="0" class="department-section-card spot-hold-billing-settings">
    <v-card-text>
      <div class="department-section-heading">
        <span><v-icon color="primary" size="20">mdi-pause-circle-outline</v-icon></span>
        <div>
          <h2>Student spot hold</h2>
          <p>Replace regular tuition with a smaller monthly charge while a family keeps the student's place.</p>
        </div>
      </div>
      <v-row>
        <v-col cols="12" sm="6">
          <v-select
            :value="settings.pricingMode"
            :items="pricingModes"
            item-text="text"
            item-value="value"
            outlined
            dense
            hide-details
            label="Hold fee calculation"
            @change="update('pricingMode', $event)"
          />
        </v-col>
        <v-col v-if="settings.pricingMode === 'PERCENT'" cols="12" sm="6">
          <v-text-field
            :value="settings.percentage"
            type="number"
            min="0"
            max="100"
            step="0.01"
            suffix="%"
            outlined
            dense
            hide-details
            class="amount-input"
            label="Percent of regular parent tuition"
            @input="update('percentage', $event)"
          />
        </v-col>
        <v-col v-else cols="12" sm="6">
          <v-text-field
            :value="settings.amount"
            type="number"
            min="0"
            step="0.01"
            prefix="$"
            outlined
            dense
            hide-details
            class="amount-input"
            label="Monthly hold fee"
            @input="update('amount', $event)"
          />
        </v-col>
      </v-row>
      <v-alert text color="primary" icon="mdi-information-outline" class="mb-0">
        Spot-held students remain enrolled. Monthly billing uses this charge instead of tuition, discounts, sponsorships, or payroll deductions until the student resumes.
      </v-alert>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "spot-hold-billing-settings",
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      pricingModes: [
        { text: "Fixed monthly amount", value: "FIXED" },
        { text: "Percentage of regular parent tuition", value: "PERCENT" },
      ],
    };
  },
  computed: {
    settings() {
      return Object.assign(
        { pricingMode: "FIXED", amount: 25, percentage: 25 },
        this.value || {}
      );
    },
  },
  methods: {
    update(field, value) {
      const numericFields = ["amount", "percentage"];
      this.$emit("input", {
        ...this.settings,
        [field]: numericFields.includes(field) ? Number(value) : value,
      });
    },
  },
};
</script>

<style scoped>
.spot-hold-billing-settings .department-section-heading {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.spot-hold-billing-settings .department-section-heading > span {
  display: flex;
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #edf7ef;
}
.spot-hold-billing-settings .department-section-heading h2 {
  margin: 0;
  color: #26332a;
  font-size: 16px;
}
.spot-hold-billing-settings .department-section-heading p {
  margin: 3px 0 0;
  color: #667269;
  font-size: 12px;
}
</style>
